<template>
  <slot :open-power-mode-sheet="() => open = true" />
  <MobileSheet
    v-model:open="open"
    title="Power mode is on"
  >
    <PowerMode
      is-mobile
      @close="open = false"
    />
  </MobileSheet>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import MobileSheet from './MobileSheet.vue'
import PowerMode from './PowerMode.vue'

const open = ref(false)
</script>
